<template>
    <fieldset>
        <h3 class="form-heading">{{ trans('basic_information') }}</h3>
        <div class="form-body">
            <txt name="server" label="name" v-model="model.name"></txt>
            <txt name="server" label="description" v-model="model.description"></txt>
            <txt name="server" label="hostname" v-model="model.hostname"></txt>
            <txt name="server" label="port" placeholder="22" v-model="model.port"></txt>
            <txt name="server" label="status_url" v-model="model.status_url"></txt>
            <txt name="server" label="username" v-model="model.username"></txt>
            <txtarea label="Secret" v-model="model.secret"></txtarea>

            <div class="buttons">
                <button @click.prevent="store" type="submit" class="btn btn-success btn-sm">
                    <i class="icon icon-save"></i> Save
                </button>
            </div>
        </div>
    </fieldset>
</template>

<script>
    export default {
        components: {
            'txtarea': require('../components/form/textarea.vue').default
        },
        props: {
            name: { default: '' },
        },
        data: function() {
            return {
                model: {
                    public_id: 0,
                    name: '',
                    description: '',
                    hostname: '',
                    port: '',
                    secret: 'hidden',
                    status_url: '',
                    username: ''
                }
            }
        },
        created() {
            this.$eventHub.$on('serverSubmit', this.store);
            this.$eventHub.$on('setServer', this.setServer);
        },
        methods: {
            store(){
                this.$store('/api/server/store', this);
            },
            setServer(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('serverSubmit', this.store);
            this.$eventHub.$off('setServer', this.setServer);
        }
    }
</script>
